var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('AppTitle',{domProps:{"textContent":_vm._s('рейтинг')}}),(_vm.loading)?_c('Preloader'):_c('AppRating',{attrs:{"user":_vm.user,"slide":_vm.slide},on:{"next":_vm.nextSlide,"prev":_vm.prevSlide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }